import { render, staticRenderFns } from "./AccountCrud.vue?vue&type=template&id=89e5052a"
import script from "./AccountCrud.vue?vue&type=script&lang=js"
export * from "./AccountCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports